import gsap from "gsap";
import Swiper, { Navigation, Autoplay, Pagination } from "swiper";
import { sliderNavigation } from "../../helpers/slider-modules-create";
document.addEventListener("DOMContentLoaded", () => {
  const bannerSwiper = document.querySelector(".banner__swiper");

  if (bannerSwiper) {
    const bannerContainer = document.querySelector(".banner__container");
    const buttonProgress = document.querySelector(".slider-navigation__button--next svg circle");
    const bannerProgress = document.querySelector(".banner__progress span");
    const swiper = new Swiper(bannerSwiper, {
      modules: [Navigation, Autoplay, Pagination],
      spaceBetween: 0,
      slidesPerView: 1,
      speed: 2000,
      loop: true,
      autoplay: {
        delay: 7000,
      },
      navigation: sliderNavigation("banner__navigation"),
      pagination: {
        el: ".swiper-pagination",
        clickable: "true",
        type: "bullets",
        bulletClass: "swiper-pagination__item",
        bulletActiveClass: "swiper-pagination__item--active",
      },
    });
    const timeline = gsap.timeline();
    let timeout;

    // Fix first active pagination item filling
    const firstPaginationItem = bannerContainer.querySelector(".swiper-pagination__item--active");
    setTimeout(() => {
      firstPaginationItem?.classList.add("swiper-pagination__item--active-custom");
    });

    // Change active class
    swiper.on("slideChange", () => {
      const paginationItemActive = bannerContainer.querySelector(".swiper-pagination__item--active");
      Array.from(bannerContainer.querySelectorAll(".swiper-pagination__item--active-custom")).forEach((el) => el.classList.remove("swiper-pagination__item--active-custom"));
      setTimeout(() => {
        paginationItemActive.classList.add("swiper-pagination__item--active-custom");
      }, 2000);
    });

    const createAnimate = () => {
      timeline.to(bannerProgress, { width: "101%", duration: 7, ease: "none" });
      timeline.to(buttonProgress, { strokeDashoffset: 179, duration: 7, ease: "none" }, "<");
    };

    const startAnimate = () => {
      timeline.pause();
      timeline.clear();
      bannerProgress.style.width = 0;
      buttonProgress.style.strokeDashoffset = 360;
      timeout = setTimeout(() => {
        createAnimate();
        timeline.play();
      }, 2000);
    };

    swiper.on("slideChange", startAnimate);
    createAnimate();
  }
});
